<template>
  <div>
    <table-base ref="table" GetAction="GetSeachList" Controller="Relation" SaveAction="AddRelatuon" :FormParams.sync="FormParams" :TopButtons="TopButtons" :TopSeach="TopSeach" :TableColumns="TableColumns" @topButtonClick="topButtonClick" :TableButtons="TableButtons"></table-base>
    <el-dialog title="预览" :visible.sync="showInfo" width="50%" :before-close="()=>{showInfo = false}">
      <span>
        <el-table border :data="ylList" style="width: 100%">
          <el-table-column v-for="item in TableColumns" :key="item.param" :prop="item.param" :label="item.name"></el-table-column>
        </el-table>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showInfo = false">取 消</el-button>
        <el-button type="primary" @click="Save">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    name: "Relation",
    title: "工资编号关联",
    data () {
      return {
        TopButtons: [
          { name: "新增", action: "add" },
          { name: "导入", action: "input", back: this.Input },
          { name: "模板下载", action: "template" },
        ],
        TopSeach: [
          { name: "", param: "input", default: "", type: "text", placeholder: "请输入关键字" }
        ],
        TableColumns: [
          { name: "用户工号", param: "userID" },
          { name: "用户姓名", param: "userName" },
          { name: "工资编号", param: "wagesID" },
        ],
        TableButtons: [
          { name: "编辑", action: "update" },
          { name: "删除", action: "del", color: "#f56c6c" },
        ],
        FormParams: [
          { name: "用户工号", param: "userID", isUpdate: true },
          { name: "用户姓名", param: "userName" },
          { name: "工资编号", param: "wagesID" },
        ],
        showInfo: false,
        ylList: []
      }
    },
    components: {
      TableBase: resolve => require(["@/components/System/components/TableBase"], resolve)
    },
    mounted () {

    },
    methods: {
      topButtonClick (type) {
        if (type == "template") {
          window.open("../../template/工号关联信息导入模板.xls");
        }
      },
      Input (res, file, fileList) {
        this.Ajax.Post("api/Relation/InputData", [res.data]).then(res => {
          this.ylList = res.data;
          this.showInfo = true;
          // this.$tool.System.msg("导入成功！", "提示", 0);
          // this.$refs.table.GetList();
        });
      },
      Save () {
        this.Ajax.Post("api/Relation/Save", this.ylList).then(res => {
          this.showInfo = false;
          this.$tool.System.msg("导入成功！", "提示", 0);
          this.$refs.table.GetList();
        });
      }
    }
  }
</script>

<style>
</style>